var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100%"}},[_c('el-container',{staticStyle:{"padding":"30px 20px"}},[_c('el-main',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingVisible),expression:"loadingVisible"}],staticStyle:{"text-align":"left","padding":"0px"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }